## Runtime

The Runtime plugin displays information about the JVM runtime.

### System Properties

Displays a filterable and sortable list of system properties.

### Metrics

Displays runtime metrics from the JVM, such as memory, CPU, garbage collection and more.

### Threads

Inspects the threads running in the JVM.
